var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('usercentrics-loader'),(_vm.showStoreCodeFallbackBar)?_c('div',{staticClass:"store-code-fallback-bar",attrs:{"role":"status"}},[_vm._v(" "+_vm._s(_vm.$t('Store code default banner', { code: _vm.activeStoreCode }))+" ")]):_vm._e(),_c(_vm.layout,{tag:"component"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }